import React from 'react';
import {Carousel} from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import './styles.css';
import {
    CFDI, CFDI2
} from './NoticiasFinanzas/ImagenesNoticias'
import {Link} from 'react-router-dom';


export default function BannerBlog(props){


    return(<>

<div class='contenedorBannerBlog'>
        <div class='seccionBlog'>
            <h1>MÁS RECIENTE</h1>
        </div>
        <div class='contenedorInternoBannerBlog'>
        <Carousel showStatus={false} showThumbs={false}>
        <div class='contenedorCarouselBlog'>
            
            <div class='imagenCarouselBlog'>
                <img src={CFDI} />
            </div>
            <div class='descripcionBlogCarousel'>
                <div class='contenedorDescripcionBlog'>
            <h1>Conoce la nueva versión del CFDI 4.0</h1>
            <h2>Facturación electrónica</h2>
            <p>La nueva versión del CFDI 4.0 entró en vigor a partir del 1 de enero de 2022. Entérate de lo que este cambio significa para poder emitir las facturas electrónicas cumpliendo con la última actualización fiscal.
A partir de la fecha obligatoria fijada por el SAT para adoptar el nuevo formato de facturación en 2022, los proveedores de timbrado deberán migrar o hacer todos los cambios necesarios en sus plataformas para adaptarse al CFDI 4.0, por lo que será mejor mantenerse al día en su sistema de facturación online.

</p>
            <div class='contenedorBotonDescripcionBlog'>
            <button><Link to='/noticiaCFDI' style={{textDecoration: 'none', color:'white'}}>Leer más</Link></button>
            </div>
        </div>
        </div>
        </div>

        <div class='contenedorCarouselBlog'>
            
            <div class='imagenCarouselBlog'>
                <img src={CFDI2} />
            </div>
            <div class='descripcionBlogCarousel'>
                <div class='contenedorDescripcionBlog'>
            <h1>Beneficios de las modificaciones al CFDI 4.0</h1>
            <h2>Facturación electrónica</h2>
            <p>Cabe apuntar el desglose de las modificaciones que traen consigo y que serán efectivas desde el arranque de 2022. Así como los cambios a la factura electrónica no solamente implican la emisión de CFDI, que pasan de la versión 3.3 a la 4.0, sino que se realizarán también ajustes a dos documentos complementarios: 
el CFDI de retenciones e información de pagos y el Complemento de recepción de pagos.
</p>
            <div class='contenedorBotonDescripcionBlog'>
            <button><Link to='/noticiaBeneficiosCFDI' style={{textDecoration: 'none', color:'white'}}>Leer más</Link></button>
            </div>
        </div>
        </div>
        </div>

       
        </Carousel>
        </div>
    </div>
    </>)
}